"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateOrgMemberRequestStruct = void 0;
const superstruct_1 = require("superstruct");
const types_1 = require("../types");
exports.UpdateOrgMemberRequestStruct = (0, superstruct_1.type)({
    placeId: (0, superstruct_1.string)(),
    organisationId: (0, superstruct_1.string)(),
    member: (0, superstruct_1.omit)(types_1.OrgMemberStruct, ['createdAt']),
});
//# sourceMappingURL=UpdateOrgMemberRequest.js.map